<div class="h-100 position-relative" [appStoryblok]="_editable">
  <img
    *ngIf="image.filename"
    [width]="width"
    [height]="height"
    [ngClass]="{ 'h-auto w-100': style === 'cover' }"
    [style.aspectRatio]="aspect_ratio + ' / 100'"
    [ngSrc]="image.filename || ''"
    [storyblokLink]="link"
    sizes="20vw"
  />
  <div class="mt-4" *ngIf="name || content._more || (link && linktext)">
    <h2 *ngIf="name" class="h5 fw-600">{{ name }}</h2>
    <div
      *ngIf="content._more"
      class="content mt-3"
      [storyblokRichText]="content"
    ></div>
    <a *ngIf="link && linktext" class="mt-3" [storyblokLink]="link">{{
      linktext
    }}</a>
  </div>
</div>
